import styled from 'styled-components'

import { Switch } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
} & ClassNameProps

export const TradeSettingsAutoToggle: React.FC<Props> = ({
  className,
  checked,
  onChange,
}) => {
  const { t } = useTranslation()

  return (
    <AutoControl className={className}>
      <AutoLabel>{t('common.auto')}</AutoLabel>
      <Switch size="s" checked={checked} onCheckedChange={onChange} />
    </AutoControl>
  )
}

const AutoControl = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const AutoLabel = styled.span`
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
